import { Button, Tooltip } from '@mui/material'
import images from 'assets/images'
import React from 'react'
import { URL_APP } from 'helpers/config'
import slack from 'helpers/integrations/slack'
import TagManager from 'react-gtm-module'
import { useParams, useSearchParams } from 'react-router-dom'

const SignUpWithSlackButton: React.FC = () => {
  const { productId } = useParams()
  const [searchParams] = useSearchParams()

  const sendGTMSignup = () => {
    TagManager.dataLayer({
      dataLayer: {
        event: 'signupFormUpdate',
        signupStep: 'signup-slack',
      },
    })
  }

  const onClick = () => {
    sendGTMSignup()
    slack.connect({
      action: 'SIGNUP',
      next: URL_APP,
      productId,
      overrideDefaultSignupAction: searchParams.get('overrideDefaultSignupAction') ?? undefined,
    })
  }

  return (
    <Tooltip title="Sign up with Slack">
      <Button
        onClick={onClick}
        variant="outlined"
        sx={{ '&, &:hover': { borderColor: '#1445FE' }, borderRadius: '99px', width: '40px', height: '40px', p: 0, minWidth: 0 }}
      >
        <img src={images.SLACK_SQUARE_LOGO} alt="Slack logo" style={{ width: '20px', height: '20px' }} />
      </Button>
    </Tooltip>
  )
}

export default SignUpWithSlackButton
